import React, { useEffect } from 'react';

import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from 'yup'
import { api } from '../../../../services/api'

import styles from './articleCreation.module.scss'
import { TagSelection } from '../TagSelection';

interface Inputs {
    ID: number,
    CM_AUTOR: string,
    CM_TITULO: string,
    CM_DESCRICAO: string,
    CM_CAT_ID: number,
    CM_CATEGORIA?: any,
    CM_CONTEUDO: string
}

interface ArticlesProps {
    catgData: any,
    articleData: any,
    changeContainerArticle: any,
    updateData: any,
    cleanArticleData: () => void;
}

interface Tag {
    CM_TAG?: string,
    CM_COD_TAG?: number
}

export function ArticleCreation(props: ArticlesProps) {

    const SignupSchema = yup.object().shape({
        CM_TITULO: yup.string()
            .required('Insira um Título')
            .min(3, 'Título muito curto')
            .max(80, 'Título muito longo'),
        CM_DESCRICAO: yup.string()
            .required('Insira um descrição')
            .min(3, 'Descrição muito curta')
            .max(300, 'Descrição muito longa'),
        CM_CAT_ID: yup.string()
            .min(1, 'Selecione uma categoria'),
        CM_CONTEUDO: yup.string()
            .required('Insira o Link do artigo')
    })

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm<Inputs>({ mode: "onChange", resolver: yupResolver(SignupSchema) })

    const [dataTags, setDataTags] = React.useState<Tag[]>([])

    const [formTags, setFormTags] = React.useState<any>()

    useEffect(() => {
        function getTags() {
            api.post('tags_create', {
                ID: props.articleData.ID
            }).then(res => setDataTags(res.data))
        }

        getTags()

        reset({
            CM_AUTOR: props.articleData.CM_AUTOR,
            CM_TITULO: props.articleData.CM_TITULO,
            CM_CAT_ID: props.articleData.CM_CAT_ID,
            CM_DESCRICAO: props.articleData.CM_DESCRICAO,
            CM_CONTEUDO: props.articleData.CM_CONTEUDO
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.articleData.ID, reset])

    useEffect(() => {
        function updateTagsToSubmit() {
            setFormTags(dataTags.map((tag: Tag) => tag.CM_COD_TAG))
        }

        updateTagsToSubmit()
    }, [dataTags])

    function updateTagsToSubmit(tags: any) {
        setFormTags(tags.map((tag: Tag) => tag.CM_COD_TAG))
    }

    function Save(data: Inputs) {

        const method = props.articleData.ID !== "" ? "put" : "post"
        const id = props.articleData.ID !== "" ? `/${props.articleData.ID}` : ''
        
        console.log('CM_AUTOR',data.CM_AUTOR)

        api[method](`/artigos${id}`, {
            CM_CAT_UNIVERSAL: data.CM_CAT_ID,
            CM_AUTOR: data.CM_AUTOR,
            CM_TITULO: data.CM_TITULO,
            CM_DESCRICAO: data.CM_DESCRICAO,
            CM_CAT_ID: data.CM_CAT_ID,
            CM_CONTEUDO: data.CM_CONTEUDO,
            TAGS: formTags
        })
            .then(function () {

                reset({
                    ID: -1,
                    CM_TITULO: '',
                    CM_DESCRICAO: '',
                    CM_CAT_ID: -1,
                    CM_AUTOR: '',
                    CM_CONTEUDO: ''
                })

                data = {
                    ID: -1,
                    CM_TITULO: '',
                    CM_DESCRICAO: '',
                    CM_AUTOR: '',
                    CM_CAT_ID: -1,
                    CM_CONTEUDO: ''
                }
            })
            .then(function () {
                setResetCard(formTags)
                props.updateData()
                props.changeContainerArticle('articleButton')
            })
            .catch(function (error) {
                console.log(error.response.data)
            })
    }

    const [/*resetCard*/, setResetCard] = React.useState([])

    function Cancel() {
        props.articleData.ID = ''
        setDataTags([])
        props.cleanArticleData()

        reset({
            ID: -1,
            CM_TITULO: '',
            CM_DESCRICAO: '',
            CM_CAT_ID: -1,
            CM_AUTOR: '',
            CM_CONTEUDO: ''
        })

        setResetCard(formTags)

        props.changeContainerArticle('articleButton')
    }

    const onSubmit = (data: Inputs) => {
        Save(data)
    }

    const currentUser = localStorage.getItem('userData') || ''
    
    return (
        <form action="" onSubmit={handleSubmit(onSubmit)} onKeyDown={(event) => { if (event.key === 'Enter') { event.preventDefault() } }}>
            <div className={styles.flexContainer}>
                <div className={styles.inputCatgContainer}>
                    <label htmlFor="">Caminho</label>
                    <select
                        {...register("CM_CAT_ID")}
                        name="CM_CAT_ID" id="CM_CAT_ID" className={styles.catgSelect}>
                        <option value="-1"  ></option>
                        {
                            props.catgData.map((categoria: {
                                ID: number,
                                CM_NOME: string,
                                path: string
                            }) => (
                                <option key={categoria.ID} value={categoria.ID}>{categoria.path}</option>
                            )
                            )
                        }
                    </select>
                    {errors.CM_CAT_ID && (<div className={styles.errorCatg}>{errors.CM_CAT_ID.message}.</div>)}
                </div>

                <div className={styles.inputTitleContainer}>
                    <label htmlFor="">Título</label>
                    <input
                        {...register("CM_TITULO")}
                        type="text" />
                    {errors.CM_TITULO && (<div className={styles.errorTitle}>{errors.CM_TITULO.message}.</div>)}
                </div>

                <div className={styles.inputDescContainer}>
                    <label htmlFor="">Descrição</label>
                    <input
                        {...register("CM_DESCRICAO")}
                        type="text" />
                    {errors.CM_DESCRICAO && (<div className={styles.errorDesc}>{errors.CM_DESCRICAO.message}.</div>)}
                </div>

                <div className={styles.inputAutorContainer}>
                    <label htmlFor="">Autor</label>
                    <input
                        {...register("CM_AUTOR")}
                        className={styles.autorInput}
                        type="text" value={JSON.parse(currentUser).name} />
                    {errors.CM_AUTOR && (<div className={styles.errorAutor}>{errors.CM_AUTOR.message}.</div>)}
                </div>
                <div className={styles.linkContainer}>
                    <label htmlFor="">Link Artigo</label>
                    <input
                        {...register("CM_CONTEUDO")}
                        type="text" />
                    {errors.CM_CONTEUDO && (<div className={styles.errorAutor}>{errors.CM_CONTEUDO.message}.</div>)}
                </div>
                <TagSelection putTagList={dataTags} updateTagsToSubmit={updateTagsToSubmit} />
            </div>
            <div className={styles.buttonFlexContainer}>
                <div className={styles.buttonContainer}>
                    <button type="button" onClick={() => Cancel()}>Cancelar</button>
                    <button type="submit">Confirmar</button>
                </div>
            </div>
        </form>
    )
}